import { axiosWithAuth, convertNumbersToString } from "helpers";

export const financialService = {
	getFinancials,
	editBankBalance,
	addFinancial,
	editFinancial,
	getBankBalances,
	addBankBalance,
	deleteFinancial,
	deleteBankBalance,
};

const API_URL = process.env.REACT_APP_API_URL;

function getFinancials(applicationId) {
	const options = {
		method: "GET",
		params: {
			applicationId,
		},
		transformResponse: [convertNumbersToString],
		url: `${API_URL}/api/underwriting/financial/getFinancials`,
	};

	return axiosWithAuth(options);
}

function addFinancial(financialModel) {
	const options = {
		method: "POST",
		data: financialModel,
		url: `${API_URL}/api/underwriting/financial/addFinancial`,
	};

	return axiosWithAuth(options);
}

function editFinancial(financialModel) {
	const options = {
		method: "POST",
		data: financialModel,
		url: `${API_URL}/api/underwriting/financial/editFinancial`,
	};

	return axiosWithAuth(options);
}

function deleteFinancial(id) {
	const options = {
		method: "DELETE",
		url: `${API_URL}/api/underwriting/financial/deleteFinancial/${id}`,
	};

	return axiosWithAuth(options);
}

function getBankBalances(applicationId) {
	const options = {
		method: "GET",
		params: {
			applicationId,
		},
		transformResponse: [convertNumbersToString],
		url: `${API_URL}/api/underwriting/financial/getBankbalances`,
	};

	return axiosWithAuth(options);
}

function addBankBalance(bankBalanceModel) {
	const options = {
		method: "POST",
		data: bankBalanceModel,
		url: `${API_URL}/api/underwriting/financial/addBankBalance`,
	};

	return axiosWithAuth(options);
}

function editBankBalance(bankBalanceModel) {
	const options = {
		method: "POST",
		data: bankBalanceModel,
		url: `${API_URL}/api/underwriting/financial/editBankBalance`,
	};

	return axiosWithAuth(options);
}

function deleteBankBalance(id) {
	const options = {
		method: "DELETE",
		url: `${API_URL}/api/underwriting/financial/deleteBankBalance/${id}`,
	};

	return axiosWithAuth(options);
}
